import { Injectable } from "@angular/core";

@Injectable()
export class EmailShippingLabel {
    ShipmentId: string;
    ToEmailAddresses: string[] = [];
    Instructions: string;
    FromEmail: string;
    PhoneNumber: string;
    AttachmentUrl: string;
}